<template>
  <div>
    <div>
    <el-button style="width: 100%"
      @click="handleCreateManifest"
      type="primary">Create Trip Summary
    </el-button>
    </div>
    <el-row>
    <div v-if="trips.length > 0">
      <TripItem  v-for="(trip, index) in trips"  :trip="trip" :key="index"/>
    </div>
    <span v-else class="h1"> NO trip has been created, Start by creating a new trip manifest </span>
  </el-row>
</div>
</template>

<script>
import { getTrips } from '@/services/trip'
import TripItem from './TripItem'

export default {
  name: 'trips',
  data () {
    return {
      trips: []
    }
  },
  components: {
    TripItem
  },
  mounted () {
    this.loadTrips()
  },
  methods: {
    handleCreateManifest () {
      this.$router.push({
        name: 'TripManifest'
      })
    },

    loadTrips () {
      const loading = this.$loading({
        lock: true,
        text: 'Fetching trips summaries',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })

      getTrips()
        .then(res => {
          this.trips = res.data
          loading.close()
        })
        .catch(() => {
          loading.close()
        })
    }
  }
}
</script>

<style lang="scss" scoped src="./trips.scss">
</style>



// WEBPACK FOOTER //
// src/components/trips/Trips.vue